// Connection state chip (PRD 002 §F9 / 001 §8). Calm, always-visible — never a
// silent stall. Composes the Badge primitive; no new design tokens.

import { Badge } from '@/components/ui/Badge'
import { cn } from '@/lib/utils'
import type { ConnState } from '@/lib/transcription/types'

const LABEL: Record<ConnState, string> = {
  idle: 'idle',
  connecting: 'connecting…',
  live: 'live',
  reconnecting: 'reconnecting…',
  paused: 'paused',
  closing: 'finishing…',
  closed: 'stopped',
  error: 'error'
}

type Variant = 'default' | 'secondary' | 'destructive' | 'outline'

const VARIANT: Record<ConnState, Variant> = {
  idle: 'outline',
  connecting: 'secondary',
  live: 'default',
  reconnecting: 'secondary',
  paused: 'secondary',
  closing: 'secondary',
  closed: 'outline',
  error: 'destructive'
}

export function ConnectionChip({
  state,
  detail
}: {
  state: ConnState
  detail?: string
}) {
  return (
    <Badge variant={VARIANT[state]} title={detail} className="gap-1.5">
      <span
        className={cn(
          'size-1.5 rounded-full bg-current',
          state === 'live' && 'animate-pulse'
        )}
      />
      {LABEL[state]}
    </Badge>
  )
}
